import React from 'react';
import CustomLeadNameCell from '../CustomLeadNameCell';

const LeadNameCell = () => ({
    field: 'lead_name',
    headerName: 'Lead Name',
    width: 240,
    minWidth: 180,
    editable: true,
    sortable: false,
    valueGetter: (params) => `${params?.row?.first_name || ''} ${params?.row?.last_name || ''}`.trim(),
    valueSetter: (params) => {
        const parts = (params?.value || '').trim().split(/\s+/);
        return { ...params.row, first_name: parts[0] || '', last_name: parts.slice(1).join(' ') };
    },
    renderCell: (params) => <CustomLeadNameCell params={params} />
});

export default LeadNameCell;
